<main>

    <!-- section -->
    <div class="section">
        <div class="container">
            <div class="main_wrapper">

                <!-- consultant wrapper -->
                <div class="consultant_wrapper">
                    <div class="consultant_wrapper_inner">
                        <button class="consultant_wrapper_close">
                            <img src="assets/img/close.png" alt="">
                        </button>
                        <div class="consultant_boxs">
                            
                            <ng-container *ngIf="slots.data.length == 0">
                                <p class="text-center text-muted">No available slots.</p>
                            </ng-container>
                            <div class="consultant_box" *ngFor="let dept of slots.data; let i = index">
                                <div class="title consultant_toggler" data-target="#consultant{{i}}">SLOTS</div>
                                <div class="consultant_box_body open" id="consultant{{i}}">
                                    <ul class="time_list">
                                        
                                        <li *ngFor="let slot of dept.slots" [ngClass]="(selectedSlot.id == slot.id) ? 'selected-slot' : ''" (click)="selectSlot(slot)">{{slot.start_time}}</li>
                                    </ul>
                                    <!--<ul class="name_list">
                                        <li>Name 01</li>
                                        
                                    </ul>-->
                                </div>
                            </div>

                            

                            
                            
                        </div>
                        <!--<div class="confirm_btn_wrap">
                            <button class="confirm_btn">Confirm</button>
                        </div>-->
                    </div>
                </div>
                
                <!-- calendar wrapper -->
                <div class="calendar_wrapper">
                    <div class="calendar_title">
                        <h3>Book your appointment</h3>
                        <h4>SELECT DATE & TIME</h4>
                    </div>
                    <div id='calendar'></div>

                    <div class="powered_by">
                        <img src="assets/img/metanoa-logo.png" alt="">
                    </div>

                    <!-- confirm popup -->
                    <div class="confirm_popup" [ngClass]="(showPopup) ? 'show' : ''">
                        <div class="confirm_popup_overlay"></div>
                        <div class="confirm_popup_body">
                            <div class="content_wrapper">
                                <div class="title">
                                    <h4 *ngIf="org == 'tbc'">Talking Brains Center</h4>
                                    <h4 *ngIf="org == 'nipmr'">NIPMR</h4>
                                </div>
                                <ul class="time_zone">
                                    <li>
                                        <span class="label">Date</span>
                                        <span class="box">{{ selectedDate | date: 'dd/MM/yyyy' }}</span>
                                    </li>
                                    <li>
                                        <span class="label">Time</span>
                                        <span class="box">{{ selectedSlot.start_time}}</span>
                                    </li>
                                    
                                </ul>
                                <div class="location">
                                    <img src="assets/img/location.png" alt="">
                                    
                                    <ng-container *ngIf="org == 'tbc'">
                                        <br>
                                        Office 505, Floor 5, Apricot Tower,  
                                        <br>
                                        Silicon Oasis, Dubai

                                    </ng-container>

                                    <ng-container *ngIf="org == 'nipmr'">
                                        <br>
                                        Kalletumkara, Thrissur, Kerala
                                        
                                    </ng-container>

                                    
                                </div>
                            </div>
                            <div class="form_wrapper">
                                <form #fbook="ngForm" (ngSubmit)="submitAppointment(fbook.value)" id="formBook" ngNativeValidate>
                                    <div class="input_group">
                                        <input type="text" ngModel name="name" placeholder="Name" required>
                                    </div>
                                    <div class="input_group">
                                        <input type="text" ngModel name="phone" placeholder="Mobile No" required>
                                    </div>
                                    <div class="input_group">
                                        <input type="email" ngModel name="email" placeholder="Email" required>
                                    </div>
                                    <div class="input_group" *ngIf="org == 'tbc'">
                                        <input type="text" ngModel name="eid" placeholder="Emirates ID">
                                    </div>
                                    <!--<div class="input_group">
                                        <input type="text" ngModel name="remarks" placeholder="Share your concerns">
                                    </div>-->
                                    <div class="input_group">
                                        <textarea ngModel name="remarks" placeholder="Share your concerns"></textarea>
                                    </div>

                                    <div class="submit">
                                        <button form="formBook" *ngIf="!submitting">Confirm</button>
                                        <p *ngIf="submitting">Please wait. We are confirming your appointment.</p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>

</main>